// extracted by mini-css-extract-plugin
export var boxItems = "_93-1";
export var boxItemsLg = "_93-2";
export var button = "_93-7";
export var buttonHoverless = "_93-9";
export var buttonLg = "_93-8";
export var filterGroupBox = "_93-0";
export var icon = "_93-3";
export var iconSecondary = "_93-6";
export var iconWrapper = "_93-4";
export var iconWrapperLg = "_93-5";
export var truncatedLabel = "_93-a";